'use client';

import { useGsapContext } from 'hooks/animation/useGsapContext';
import gsap from 'gsap';
import { useEffect, useRef } from 'react';
import { Container } from '..';
import { useTranslations } from 'next-intl';
import styles from './PointsExplainerSection.module.css';

export const PointsExplainerSection = ({
  className,
}: {
  className?: string;
}) => {
    const t = useTranslations('powerplugs');
    const gsapContext = useGsapContext();
    const intersectionObserver = useRef<IntersectionObserver | null>(null);
    // const animInitialised = useRef(false);

    const container = useRef<HTMLDivElement>(null);

    const animationInit = () => {
      console.log('LOG');
      if (!container.current) return;
      gsapContext.add(() => {
        const tl = gsap.timeline({
          defaults: {
            duration: 1,
            ease: 'power2.easeInOut',
          },
          scrollTrigger: {
            trigger: '.content',
            start: 'top 85%',
            end: 'bottom 60%',
            scrub: 0.1,
            immediateRender: false,
          },
        });

        tl.set('.point-element', {
          autoAlpha: 0,
        });

        tl.fromTo(
          '.point-element',
          {
            autoAlpha: 0,
            y: 20,
          },
          {
            autoAlpha: 1,
            y: 0,
            stagger: 0.4,
          },
          0.2,
        );

        // tl.addPause(1.5);
      });
      // animInitialised.current = true;
    };

    useEffect(() => {
      intersectionObserver.current = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animationInit();
            } else {
              // none
            }
          });
        },
        {
          threshold: 0,
          rootMargin: '0px',
        },
      );

      intersectionObserver.current.observe(container.current as Element);

      return () => {
        if (intersectionObserver.current) {
          intersectionObserver.current.disconnect();
        }
      };
    }, []);

    return (
      <section
        className={[styles.root, className].filter(Boolean).join(' ')}
        ref={container}
      >
        <Container className="content">
          <div className="point-element">
            <h4>{t('powerplugsPage.points.one.title')}</h4>
            <p>{t('powerplugsPage.points.one.body')}</p>
          </div>

          <div className="point-element">
            <h4>{t('powerplugsPage.points.two.title')}</h4>
            <p>{t('powerplugsPage.points.two.body')}</p>
          </div>

          {/* <div className="point-element">
            <h4>A third point if required</h4>
            <p>
              A hub for all things health, new age appstore lorem ispum copy.
            </p>
          </div> */}
        </Container>
      </section>
    );
};
